<template>
    <div class="page">
        <div class="header">
            <div class="btns">
                <el-button size="mini" @click="() => {
                    this.form = {}
                    this.dialogVisible = true
                }" icon="el-icon-plus" type="defalut">新建</el-button>
                <el-button size="mini" @click="getData" icon="el-icon-refresh">刷新</el-button>
            </div>
            <el-page-header @back="$router.go(-1)" content="职业健康档案" />
        </div>
        <div class="search">
            <el-form :inline="true" :model="search" size="small">
                <el-form-item label="二级单位">
                    <el-input v-model="search.EJDW" placeholder="请输入" clearable />
                </el-form-item>
                <el-form-item label="姓名">
                    <el-input v-model="search.XM" placeholder="请输入" />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" plain @click="getData">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="main-content">
            <div class="table-content">
                <el-table :data="table.data" border stripe size="mini" v-loading="loading" width="100%" height="100%"
                    :header-cell-style="{ backgroundColor: '#FAFAFA' }">
                    <el-table-column type="index" label="序号" align="center"
                        :index="(index) => { return (this.table.page - 1) * this.table.pageSize + index + 1 }"
                        width="55" />
                    <el-table-column prop="EJDW" label="二级单位" />
                    <el-table-column prop="SJDW" label="三级单位" />
                    <el-table-column prop="XM" label="姓名" />
                    <el-table-column prop="XB" label="性别" />
                    <el-table-column prop="NL" label="年龄" />
                    <el-table-column prop="GZ" label="工种" />
                    <el-table-column prop="SFZG" label="是否在岗" width="120" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.SFZG ? '是' : '否' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="created_at" label="创建时间" width="220" align="center" />
                    <el-table-column align="center" width="120" label="操作" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="warning" size="mini" @click="handleUpdate(scope.row)" icon="el-icon-edit">
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="pager">
            <el-pagination layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 30, 50, 100, 200, 500, 1000]"
                :current-page="table.page" :total="table.total" :page-size="table.pageSize"
                @current-change="handlePageChange" @size-change="handlePageSizeChange" />
        </div>
        <data-form :visible="dialogVisible" :form="form" @close="dialogVisible = false" @update="getData" />
    </div>
</template>

<script>
import DataForm from './widgets/dataForm'
export default {
    components: {
        DataForm
    },
    data() {
        return {
            loading: false,
            dialogVisible: false,
            search: { type: 'appoint' },
            form: {},
            table: {
                data: [],
                total: 0,
                page: 1,
                pageSize: 20
            }
        }
    },
    methods: {
        handlePageChange(e) {
            this.table.page = e
            this.getData()
        },
        handlePageSizeChange(e) {
            this.table.pageSize = e
            this.getData()
        },
        handleUpdate(row) {
            this.form = JSON.parse(JSON.stringify(row))
            this.dialogVisible = true
        },
        async getData() {
            this.loading = true
            try {
                const resp = await this.$http.get(`/industrial/data?page=${this.table.page}&pageSize=${this.table.pageSize}&status=1`, { params: this.search })
                if (!resp.data) {
                    this.$message.error(resp.data.msg)
                } else {
                    this.table.data = resp.data.records
                    this.table.total = resp.data.total
                }
            } catch (error) {
                this.$message.error(error.message)
            }
            this.loading = false
        }
    },
    mounted() {
        this.getData()
    }
}
</script>

<style lang="scss" scoped>
.page {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.header {
    padding-bottom: 10px;

    .btns {
        float: right;
    }
}

.search {
    padding: 10px;
    background-color: #FAFAFA;
    border-top: 1px solid #EBEEF5;
    border-left: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;

    ::v-deep .el-form-item {
        padding: 0 !important;
        margin-bottom: 0 !important;
    }
}

.main-content {
    flex: 1;
    position: relative;
}

.table-content {
    position: absolute;
    width: 100%;
    height: 100%;
}

.pager {
    padding-top: 10px;
    text-align: center;
}
</style>
